import { useNavigate } from "react-router-dom-v5-compat";
import {
  HOTELS_AVAILABILITY_PATH,
  HotelNavigationUtility,
} from "@b2bportal/core-utilities";
import { useExperiment } from "@hopper-b2b/experiments";
import { useSessionContext } from "@/components/AuthModule/SessionContext";
import {
  buildCarsAvailabilityUrl,
  buildPlatformAvailabilityUrl,
} from "@/utils/commerce/urls";
import type { RecentSearch } from "@/utils/useRecentSearches";

export const useRecentSearchNavigation = () => {
  const navigate = useNavigate();
  const { sessionInfo } = useSessionContext();

  const staysPlatformEnabled = useExperiment(
    "StaysCommercePlatformPerkSpotRollout"
  );

  return (search: RecentSearch) => {
    if (search.type === "hotel") {
      if (staysPlatformEnabled) {
        window.location.href = buildPlatformAvailabilityUrl({
          place: search.place,
          dateRange: { from: search.fromDate, until: search.untilDate },
          guests: search.guests,
          roomsCount: search.roomsCount,
          perkspotUserId: sessionInfo?.userDetails.tenantUserId,
          communityId: sessionInfo?.userDetails.communityId,
        });
        return;
      }

      const destinationCode = HotelNavigationUtility.placeLabelAndSublabelToUrl(
        search.label,
        search.subLabel
      );
      const searchParams = HotelNavigationUtility.buildSearchParams({
        dateRange: { from: search.fromDate, until: search.untilDate },
        guests: search.guests,
        roomsCount: search.roomsCount,
      });

      navigate(
        `${HOTELS_AVAILABILITY_PATH}/${destinationCode}?${searchParams.toString()}`
      );
    } else {
      const url = buildCarsAvailabilityUrl({
        pickupDate: search.pickupDate,
        dropoffDate: search.dropoffDate,
        pickupTime: search.pickupTime,
        dropoffTime: search.dropoffTime,
        driverAge: search.driverAge,
        pickupLocationIdentifier: search.pickupLocation.identifier,
        dropoffLocationIdentifier: search.dropoffLocation.identifier,
        perkspotUserId: sessionInfo?.userDetails.tenantUserId,
        communityId: sessionInfo?.userDetails.communityId,
      });
      window.location.href = url;
    }
  };
};
